<template>
    <footer class="bg-accent py-5">
        <div class="container flex flex-col md:flex-row gap-8 my-8">
            <div class="md:w-2/5 lg:w-lg text-white">
                <img
                    :src="cdnUrl + '/assets/images/trusted-parts-logo.svg'"
                    alt="TrustedParts.com"
                    class="mb-4"
                    loading="lazy"
                    width="275"
                    height="40" />
                <div class="text-lg" v-html="$t('Layout.MissionStatement_Subtitle')"></div>
                <p class="mt-4" v-html="$t('Layout.MissionStatement_Paragraph1')"></p>
                <p v-html="$t('Layout.MissionStatement_Paragraph2')"></p>
                <p v-html="$t('Layout.MissionStatement_Paragraph3')"></p>
                <p v-html="$t('Layout.MissionStatement_LinkText')"></p>
            </div>
            <div class="md:w-2/5 lg:w-md lg:ml-auto">
                <FooterSearchBox />
                <NuxtLink
                    id="lnkFooterBulkSearch"
                    class="inline-block mt-8 mb-10 text-xl font-bold text-accent-secondary hover:text-accent-secondary hover:no-underline"
                    :href="localePath('/bom/import')"
                    :title="$t('Layout.BulkSearchLinkText')">
                    {{ $t("Layout.BulkSearchLinkText") }}
                </NuxtLink>

                <div class="flex flex-row justify-between mr-1 ml-1">
                    <div class="w-full sm:w-5/12 flex flex-col items-start space-y-5">
                        <NuxtLinkLocale
                            v-for="link in leftLinks"
                            :id="link.id"
                            :key="link.id"
                            :to="link.to"
                            :title="$t(link.labelKey)"
                            class="text-white hover:text-white">
                            {{ $t(link.labelKey) }}
                        </NuxtLinkLocale>
                        <a
                            href="http://www.ecianow.org/"
                            target="_blank"
                            rel="noopener"
                            title="ecianow.org"
                            class="text-white hover:text-white">
                            ecianow.org
                        </a>
                        <a
                            href="https://www.linkedin.com/company/trustedparts-com/"
                            target="_blank"
                            rel="noopener"
                            title="LinkedIn">
                            <img src="~/assets/icons/linkedin-logo.svg" class="h-6" alt="LinkedIn" />
                        </a>
                    </div>
                    <div class="w-full sm:w-5/12 flex flex-col items-start space-y-5">
                        <NuxtLinkLocale
                            v-for="link in rightLinks"
                            :id="link.id"
                            :key="link.id"
                            :to="link.to"
                            :title="$t(link.labelKey)"
                            class="text-white hover:text-white">
                            {{ $t(link.labelKey) }}
                        </NuxtLinkLocale>
                    </div>
                </div>
            </div>

            <div class="my-4 footerIPTheftLogo">
                <a href="http://www.iprcenter.gov/disclaimer/" :title="$t('Layout.IPTheftLogoTitle')" rel="noopener">
                    <img
                        :src="cdnUrl + '/assets/images/reportiptheftbutton.png'"
                        :alt="$t('Layout.IPTheftLogoTitle')"
                        width="80"
                        height="80"
                        loading="lazy" />
                </a>
            </div>
        </div>
        <div class="mt-5 text-center text-white">©{{ currentYear }} Electronic Components Industry Association</div>
    </footer>
</template>
<script setup>
const config = useRuntimeConfig();
const globalConfig = useStateGlobalConfig();
const cdnUrl = config.public.cdnUrl;
const localePath = useLangPath();
const currentYear = new Date().getFullYear();

const leftLinks = [
    { id: "lnkFooterAboutUs", to: "/about-us", labelKey: "Layout.LinkAbout" },
    { id: "lnkFooterBlog", to: "/blog", labelKey: "Layout.LinkBlog" },
    { id: "lnkFooterContact", to: "/contact-us", labelKey: "Layout.LinkContact" },
    { id: "lnkFooterDocumentation", to: "/docs", labelKey: "Layout.LinkDocumentation" },
];

const rightLinks = [
    { id: "lnkManufacturers", to: "/manufacturers", labelKey: "Layout.LinkManufacturers" },
    { id: "lnkPrivacyPolicy", to: "/privacy-policy", labelKey: "Layout.LinkPrivacyPolicy" },
    { id: "lnkFooterSiteMap", to: "/sitemap", labelKey: "Layout.LinkSitemap" },
    { id: "lnkTermsAndConditions", to: "/terms-and-conditions", labelKey: "Layout.LinkTerms" },
];

if (globalConfig.value.Features.TRUSTED_INSIGHTS) {
    rightLinks.splice(0, 0, { id: "lnkInsights", to: "/authorized-channel-insights", labelKey: "Layout.LinkInsights" });
}
</script>
